import React from "react";
import styles from "./CV.module.scss";

const CV = () => {
  return (
    <div className={`cvRef ${styles.cv}`}>
      <h2 className={styles.cv__title}>C.V.</h2>
      <div className={styles.cv__item}>
        <h2 className={styles.cv__item__title}>Education</h2>
        <p>
          <span className={styles.year}>1996</span>
          <span className={styles.location}>
            University of Art, Yerevan, Armenia
          </span>
        </p>
        <p>
          <span className={styles.year}>2000</span>
          <span className={styles.location}>
            University of Art, Yerevan, Armenia
          </span>
        </p>
      </div>
      <div className={styles.cv__item}>
        <h2 className={styles.cv__item__title}>Exhibitions</h2>
        <p>
          <span className={styles.year}>1996</span>
          <span className={styles.location}>
            Museum of Art, Yerevan, Armenia
          </span>
        </p>
        <p>
          <span className={styles.year}>2000</span>
          <span className={styles.location}>
            Museum of Art, Yerevan, Armenia
          </span>
        </p>
        <p>
          <span className={styles.year}>2002</span>
          <span className={styles.location}>
            Museum of Art, Yerevan, Armenia
          </span>
        </p>
        <p>
          <span className={styles.year}>2004</span>
          <span className={styles.location}>
            Museum of Art, Yerevan, Armenia
          </span>
        </p>
      </div>
    </div>
  );
};

export default CV;
